import cx from 'classnames';
import {RefObject} from 'react';
import Skeleton from 'react-loading-skeleton';
import {FileDropZone} from '~/common/components/FileDropZone/FileDropZone';
import {PhotoGalleryTile} from '~/ViewInvitation/routes/Photos/PhotoGalleryTile';
import {PhotosEmptyState} from '~/ViewInvitation/routes/Photos/PhotosEmptyState/PhotosEmptyState';

interface UploadedPhoto {
  id: string;
  photo_id: string | number; // biome-ignore lint/style/useNamingConvention: from api
  user_id: string; // biome-ignore lint/style/useNamingConvention: from api
  url: string;
  width: number;
  height: number;
  position: number | null;
}

interface PendingPhoto {
  id: string;
  file: File;
  status: 'pending';
}

type Photo = UploadedPhoto | PendingPhoto;

interface PhotoGalleryEditorListProps {
  combinedPhotos: Photo[];
  isLoading: boolean;
  isHostModule: boolean;
  onViewPhotoFn: (photo: Photo, index: number) => void;
  handleFeaturePhoto: (photo: Photo) => void;
  handleDeletePhoto: (id: string | number) => void;
  fileUploadRef: RefObject<HTMLInputElement>;
  photoCount: number;
  isMediumAndUp: boolean;
  listRef: RefObject<HTMLDivElement>;
}

const loadingSkeletons = (count: number) =>
  new Array(count)
    .fill(null)
    // biome-ignore lint/suspicious/noArrayIndexKey: order is static and won't change
    .map((_, i) => <Skeleton key={i} className="photo-gallery__photo-tile-skeleton" />);

export function PhotoGalleryEditorList({
  combinedPhotos,
  isLoading,
  isHostModule,
  onViewPhotoFn,
  handleFeaturePhoto,
  handleDeletePhoto,
  fileUploadRef,
  photoCount,
  isMediumAndUp,
  listRef,
}: PhotoGalleryEditorListProps) {
  if (photoCount === 0 && !isLoading) {
    return (
      <FileDropZone inputRef={fileUploadRef} hasBorder>
        <PhotosEmptyState
          emptyStateText="Psst... add photos to share with other guests!"
          fileUploadRef={fileUploadRef}
          isHostModule={isHostModule}
        />
      </FileDropZone>
    );
  }

  return (
    <div
      className={cx('photo-editor__photos', {
        'photo-editor__photos-host': isHostModule,
      })}
      ref={listRef}
    >
      {isLoading
        ? loadingSkeletons(isMediumAndUp ? 20 : 15)
        : combinedPhotos?.map((p, i) => (
            <PhotoGalleryTile
              key={p.id}
              // @ts-expect-error TODO: convert PhotoGalleryTile to ts
              photo={p}
              isHostModule={isHostModule}
              featured={i === 0}
              onViewPhotoFn={onViewPhotoFn}
              handleFeaturePhoto={handleFeaturePhoto}
              handleDeletePhoto={handleDeletePhoto}
              handleOpenContextMenu={handleFeaturePhoto}
            />
          ))}
    </div>
  );
}
